import Parallax from './modules/Parallax';

function init() {
  document.querySelectorAll('[data-plugin-parallax]').forEach(item => {
    if (item instanceof HTMLElement) {
      const optionsString = item.getAttribute('data-plugin-options');

      let options = {};
      if (optionsString) {
        try {
          options = JSON.parse(optionsString);
        } catch (e) {
          options = {};
        }
      }
      new Parallax(item, Object.assign({supportsWebp: supportsWebp()}, options));
    }
  });
}

function supportsWebp() {
  const elem = document.createElement('canvas');

  if (!!(elem.getContext && elem.getContext('2d'))) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }

  return false;
}

window.addEventListener('load', init, false);
